
<ciciam-frame-front>
  <ciciam-form-forgot-password #forgotPasswordForm
    (submit)="onForgotPassword($event)"
    (backToLogin)="onBackToLoginClick()"
    (forgotPassword)="onForgotPasswordClick()"
  ></ciciam-form-forgot-password>
</ciciam-frame-front>
